import { useTranslation } from 'react-i18next';
import { Text } from '../../components/typography';
import { calculateRisk } from '../../utilities/riskMatrix';
import { getLocalTime } from '../../utilities/time';
import { getTranslationKey } from '../../utilities/translator/translation_keys';
import styles from './InspectionIncidentHeader.module.scss';
import Label from '../../components/action_items/Label';

export default function InspectionIncidentHeader({ incident }) {
  const {
    title,
    description,
    dateOfIncident,
    impact,
    probability,
    initialImpact,
    initialProbability,
    type,
    subtype,
  } = incident || {};
  const { t } = useTranslation();
  const i = impact || initialImpact;
  const p = probability || initialProbability;
  const risk = i * p;
  const riskLevel = calculateRisk(risk);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <div className={styles.flexRow}>
            <div>
              <Text noMargin weight="bold" size="lg" color="primary">
                {`${t(getTranslationKey(type, 'incidents')) || type} -  ${
                  t(getTranslationKey(subtype, 'incidents')) ||
                  subtype ||
                  'Subtype Required**'
                }
                  `}
              </Text>
              <Text noMargin>
                {getLocalTime(dateOfIncident)?.format(
                  'dddd, MMMM Do YYYY @ HH:mm',
                )}
              </Text>
            </div>
          </div>
          <Text noMargin prewrap weight="semiBold">
            {title || 'No Title'}
          </Text>
          <Text noMargin prewrap>
            {description}
          </Text>
        </div>
        <div className={styles.riskLevel}>
          <Text noMargin weight="bold" size="md-lg">
            {`${incident?.externalId}`}
          </Text>
          {!!i && !!p ? (
            <Text
              noMargin
              size="sm"
              textAlign="right"
              weight="semiBold"
              color="secondary"
            >{`Impact: ${i} Probability: ${p}`}</Text>
          ) : null}
          {!!riskLevel?.level && (
            <div className={styles.flexRight}>
              <Label
                name={`${riskLevel?.level} Risk`}
                color={riskLevel?.textColor}
                rowSized={false}
              />
            </div>
          )}
        </div>
      </div>
      <br />
    </div>
  );
}
